import { ProductType } from '@tink/core/src/types';

export enum ProductDimensionPay {
  DIRECT = 'direct',
  CREDENTIALS = 'credentials',
  BULK = 'bulk',
  VRP_MANDATE = 'vrp-mandate',
  VRP_MANDATE_PICKUP = 'vrp-mandate-pickup',
  ANY = 'any',
}

export enum ProductDimensionAuthorize {
  CONNECT = 'connect',
}

export enum ProductDimensionIncomeCheck {
  CONNECT = 'connect',
  CREATE_REPORT = 'create-report',
}

export enum ProductDimensionExpenseCheck {
  CREATE_REPORT = 'create-report',
}

export enum ProductDimensionAccountCheck {
  CREATE_REPORT = 'create-report',
  UPDATE_CONSENT = 'update-consent',
  /**
   * @deprecated use CREATE_REPORT instead
   */
  CONNECT = 'connect',
}

export enum ProductDimensionBusinessAccountCheck {
  CREATE_REPORT = 'create-report',
}

export enum ProductDimensionCredentials {
  ADD = 'add',
  REFRESH = 'refresh',
  AUTHENTICATE = 'authenticate',
}

export enum ProductDimensionTransactions {
  UPDATE_CONSENT = 'update-consent',
  CONNECT_ACCOUNTS = 'connect-accounts',
  // Legacy dimension that we still need to support
  ADD_ACCOUNTS = 'add-accounts',
}

export enum ProductDimensionReports {
  CREATE_REPORT = 'create-report',
}

export enum ProductDimensionRiskInsights {
  CREATE_REPORT = 'create-report',
}

export enum ProductDimensionProducts {
  UPDATE_CONSENT = 'update-consent',
  CONNECT_ACCOUNTS = 'connect-accounts',
}

export enum ProductDimensionExtendConsent {
  EXTEND_CONSENT = 'extend-consent',
}

export type ProductDimension =
  | ProductDimensionPay
  | ProductDimensionAuthorize
  | ProductDimensionAccountCheck
  | ProductDimensionBusinessAccountCheck
  | ProductDimensionIncomeCheck
  | ProductDimensionCredentials
  | ProductDimensionTransactions
  | ProductDimensionReports
  | ProductDimensionRiskInsights
  | ProductDimensionProducts
  | ProductDimensionExpenseCheck
  | ProductDimensionExtendConsent;

export enum ProductNames {
  PRODUCT_UNKNOWN = 'PRODUCT_UNKNOWN',
  PRODUCT_REAL_TIME_BALANCE = 'PRODUCT_REAL_TIME_BALANCE',
  PRODUCT_PAYMENT_INITIATION = 'PRODUCT_PAYMENT_INITIATION',
  PRODUCT_ACCOUNT_AGGREGATION = 'PRODUCT_ACCOUNT_AGGREGATION',
  PRODUCT_ACCOUNT_CHECK = 'PRODUCT_ACCOUNT_CHECK',
  PRODUCT_INCOME_CHECK = 'PRODUCT_INCOME_CHECK',
  PRODUCT_MONEY_MANAGER = 'PRODUCT_MONEY_MANAGER',
  PRODUCT_TRANSACTIONS = 'PRODUCT_TRANSACTIONS',
  PRODUCT_BUSINESS_TRANSACTIONS = 'PRODUCT_BUSINESS_TRANSACTIONS',
  PRODUCT_RISK_INSIGHTS = 'PRODUCT_RISK_INSIGHTS',
  PRODUCT_BUSINESS_ACCOUNT_CHECK = 'PRODUCT_BUSINESS_ACCOUNT_CHECK',
  PRODUCT_EXPENSE_CHECK = 'PRODUCT_EXPENSE_CHECK',
  PRODUCT_INVESTMENTS = 'PRODUCT_INVESTMENTS',
  PRODUCT_LOANS = 'PRODUCT_LOANS',
}

export type ExtendConsentProduct =
  | ProductType.TRANSACTIONS
  | ProductType.BUSINESS_TRANSACTIONS
  | ProductType.ACCOUNT_CHECK
  | ProductType.PRODUCTS
  | ProductType.CREDENTIALS;

export const isUpdateConsent = (productType: ProductType, productDimension: ProductDimension) => {
  const transactionsUpdateConsent =
    productType === ProductType.TRANSACTIONS &&
    productDimension === ProductDimensionTransactions.UPDATE_CONSENT;

  const productsUpdateConsent =
    productType === ProductType.PRODUCTS &&
    productDimension === ProductDimensionProducts.UPDATE_CONSENT;

  const accountCheckUpdateConsent =
    productType === ProductType.ACCOUNT_CHECK &&
    productDimension === ProductDimensionAccountCheck.UPDATE_CONSENT;

  return transactionsUpdateConsent || productsUpdateConsent || accountCheckUpdateConsent;
};

export const isExtendConsent = (productDimension: ProductDimension) => {
  return productDimension === ProductDimensionExtendConsent.EXTEND_CONSENT;
};
